import { render, staticRenderFns } from "./ModalStatusExpedient.vue?vue&type=template&id=21e010b6&"
import script from "./ModalStatusExpedient.vue?vue&type=script&lang=ts&"
export * from "./ModalStatusExpedient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports